import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import theme from './theme';
import AppRoutes from './routes';
import AuthProvider from './providers/AuthProvider';
import { EntityProvider } from './context/EntityContext';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <EntityProvider>
            <AppRoutes />
          </EntityProvider>
        </AuthProvider>
      </StyledThemeProvider>
    </ThemeProvider>
  );
};

export default App;